import { useFormik } from 'formik';
import Select from 'react-select';
import { Card, CardFooter, CardBody, CardHeader } from '@components/card/card';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import Loading from '@components/Shared/Loader/Loading';
import { useEffect } from 'react';
import { getPurchaseOrderById, cleanUpPurchaseOrderById } from '@store/purchases/PurchaseOrder/purchaseOrderSlice';
import POLines from './POLines';
import { TreeSelect } from 'antd';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

const ViewPO = ({ purchaseOrderId }: { purchaseOrderId: string }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { Currency, loading: loading1, error: error1 } = useLookupCurrency();
  const { PaymentMethodList, loading: loading2, error: error2 } = useGetPaymentMethod();
  const { InventoryOptions, loading: loading3, error: error3 } = useGetInventoryWithPermission();
  const { OperatingUnitOptions, loading: loading4, error: error4 } = useGetOperatingUnitWithPermission();
  const { treeSuppliersData, loading: loading5, error: error5 } = useGetSuppliersList();

  const { PurchaseOrderById: data, loading, error } = useAppSelector(s => s.PurchaseOrder);

  useEffect(() => {
    if (purchaseOrderId) {
      dispatch(getPurchaseOrderById(purchaseOrderId));
    }
    return () => {
      dispatch(cleanUpPurchaseOrderById());
    };
  }, [dispatch, purchaseOrderId]);

  const formik = useFormik({
    initialValues: {
      id: data ? data.id : '',
      // no: data ? data.no : '',
      code: data ? data.code : '',
      // name: data ? data.name : '',
      // name2: data ? data.name2 : '',
      // transTypeId: data ? data.transTypeId : '',
      organizationId: data ? data.organizationId : '',
      peopleId: data ? data.peopleId : '',
      recipientname: data ? data.recipientname : '',
      billToLocationId: data ? data.billToLocationId : '',
      shipToLocationId: data ? data.shipToLocationId : '',
      referenceId: data ? data.referenceId : '',
      transactionDate: data ? data.transactionDate?.split('T')[0] : '',
      deliveryDate: data ? data.deliveryDate?.split('T')[0] : '',
      expirationDate: data ? data.expirationDate?.split('T')[0] : '',
      dueDate: data ? data.dueDate?.split('T')[0] : '',
      paymentTermsId: data ? data.paymentTermsId : '',
      description: data ? data.description : '',
      grossAmount: data ? data.grossAmount : '',
      discountRate: data ? data.discountRate : '',
      discountAmount: data ? data.discountAmount : '',
      vat: data ? data.vat : '',
      netAmount: data ? data.netAmount : '',
      isAme: true,
      ameStatus: data ? data.ameStatus : 0,
      personId: data ? data.personId : '',
      contractId: data ? data.contractId : 'e',
      paymentTerms: data ? data.paymentTerms : '',
      deliveryTerm: data ? data.deliveryTerm : '',
      inventoryId: data ? data.inventoryId : '',
      waybill: data ? data.waybill : '',
      phone: data ? data.phone : '',
      currencyCode: data ? data.currencyCode : '',
      currencyConversionRate: data ? data.currencyConversionRate : '',
      batchId: data ? data.batchId : '',
      paymentMethodId: data ? data.paymentMethodId : '',
      transactionsLinesList:
        data?.transactionsLinesList?.map(item => ({
          id: item.id,
          // transactionId: item.transactionId,
          itemId: item.itemId,
          lineNumber: item.lineNumber,
          uom: item.uom,
          description: item.description,
          price: item.price,
          qty: item.qty,
          discountRate: item.discountRate,
          discountAmount: item.discountAmount,
          vatRate: item.vatRate,
          total: item.total,
          vatAmount: item.vatAmount,
          // unitCost: item.unitCost,
          // codeCombinationId: item.codeCombinationId,
          // currencyCode: item.currencyCode,
          // currencyConversionRate: item.currencyConversionRate,
          // lotId: item.lotId,
          // headerId: item.headerId,
          // lineId: item.lineId,
          inventoryId: item.inventoryId,
          // type: item.itemId === null ? 'Non_Inv' : 'Inv'
          type: item.itemType
        })) || []
    },

    enableReinitialize: true,
    onSubmit: values => {}
  });

  const { values, errors, touched } = formik;

  //#endregion

  // console.log(values.paymentMethodId);

  return (
    <>
      <Card>
        <CardHeader className='d-flex items-center gap-2 font-semibold'>
          <i className='fa-solid fa-clipboard-list text-theme'></i>
          تفاصيـل أمر الشـراء
        </CardHeader>

        <Loading
          loading={loading || loading1 || loading2 || loading3 || loading4 || loading5}
          error={error || error1 || error2 || error3 || error4 || error5}
        >
          <CardBody>
            <div className='row'>
              <div className='col-lg-2'>
                <div className='form-group flex-nowrap mb-3'>
                  <label className='form-label'>{t('رقم أمر الشراء')}</label>
                  <div className='input-group flex-nowrap'>
                    <Form.Control
                      readOnly
                      className='form-control fw-bold fs-6 text-theme'
                      type='text'
                      autoComplete='off'
                      defaultValue={values.code || ''}
                    />
                  </div>
                </div>
              </div>

              <div className='col-lg-2'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('تـاريخ أمر الشراء')}</label>
                  <Form.Control
                    readOnly
                    className='form-control'
                    type='date'
                    name='transactionDate'
                    defaultValue={values.transactionDate || ''}
                  />
                </div>
              </div>

              <div className='col-lg-2'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('تاريخ التسليـم')}</label>
                  <Form.Control
                    readOnly
                    className='form-control'
                    type='date'
                    name='deliveryDate'
                    defaultValue={values.deliveryDate || ''}
                    isInvalid={!!(touched.deliveryDate && errors.deliveryDate)}
                  />
                </div>
              </div>

              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('الوحدة التشغيليـة')}</label>

                  <Select
                    isDisabled
                    classNamePrefix='react-select'
                    isSearchable={true}
                    isClearable
                    options={OperatingUnitOptions}
                    value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>

              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('المخزن')}</label>

                  <Select
                    isDisabled
                    classNamePrefix='react-select'
                    isSearchable
                    isClearable
                    options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.organizationId)}
                    value={
                      formik.values.inventoryId &&
                      InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)
                    }
                    onChange={option => formik.setFieldValue('inventoryId', option?.value || null)}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
              <div className='col-lg-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('المورد')}</label>
                  <TreeSelect
                    disabled
                    showSearch
                    // value={value}
                    className='w-100'
                    treeLine
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    allowClear
                    value={formik.values.peopleId}
                    treeData={treeSuppliersData}
                    treeNodeFilterProp='title'
                  />
                </div>
              </div>
              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('PaymentMethod')}</label>
                  <Form.Select
                    disabled
                    className='form-select'
                    name='paymentMethodId'
                    defaultValue={formik.values.paymentMethodId}
                  >
                    <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                    {PaymentMethodList?.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {i18n.language === 'ar' ? item.name2 : item.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>
              <div className='col-lg-2'>
                <div className='form-group mb-3'>
                  <label className='form-label'> {t('Currency')} </label>
                  <Form.Select
                    disabled
                    className='form-select'
                    name='currencyCode'
                    defaultValue={values.currencyCode || ''}
                  >
                    {Currency &&
                      Currency?.map((item: any, idx: number) => (
                        <option key={++idx} value={item.currencyCode}>
                          {item.description}
                        </option>
                      ))}
                  </Form.Select>
                </div>
              </div>
              <div className='col-lg-2'>
                <div className='form-group mb-3'>
                  <label className='form-label'> {t('CurrencyConversionRate')} </label>
                  <Form.Control
                    readOnly
                    className='form-control  text-center'
                    type='text'
                    defaultValue={values.currencyConversionRate}
                  />
                </div>
              </div>

              <div className='col-lg-6'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('الشروط')}</label>
                  <Form.Control
                    readOnly
                    className='form-control'
                    as='textarea'
                    rows={2}
                    name='paymentTerms'
                    defaultValue={values.paymentTerms}
                  />
                </div>
              </div>

              <div className='col-lg-6'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Note')}</label>
                  <Form.Control
                    readOnly
                    className='form-control'
                    as='textarea'
                    rows={2}
                    name='description'
                    onChange={formik.handleChange}
                    defaultValue={values.description}
                  />
                </div>
              </div>
            </div>
          </CardBody>

          <CardFooter className='px-0 py-1'>
            <div className='row'>{Object.keys(data)?.length > 0 && <POLines formik={formik} />}</div>
          </CardFooter>
        </Loading>
      </Card>
    </>
  );
};

export default ViewPO;
